import React from "react";
import { Chip } from "@mui/material";

import { JOB_STATUSES } from "../../constants";

const flow = {
  [JOB_STATUSES.NOT_STARTED]: "grey",
  [JOB_STATUSES.IN_PROGRESS]: "green",
  [JOB_STATUSES.COMPLETE]: "main",
};
const OrderLineItemChip = ({ state = "", status }) => {
  const label = state || JOB_STATUSES.NOT_STARTED;
  const finalLabel = !isNaN(status) ? Object.values(JOB_STATUSES)[status] : label;

  return (
    <Chip
      label={finalLabel}
      variant="colorTag"
      flow={flow[finalLabel]}
      sx={{
        margin: "6px",
        "& .MuiChip-label": {
          fontSize: 10,
        },
      }}
    />
  );
};

export default OrderLineItemChip;
